<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-23 15:28:35
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-10-09 16:06:45
-->
<template>
	<div class="rule-card">
		<div class="title">
			{{ title }}
			<span class="rule-explain" @click="$emit('showRuleExplainDialog', flag)">《规则说明》</span>
		</div>
		<div v-if="flag !== 3" class="fz-14 mt-8 yx-color-text-regular">{{ !status ? '不' : '' }}允许</div>
		<div v-else class="fz-14 mt-8 yx-color-text-regular">{{ text }}</div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'ruleCard',
	props: {
		title: {
			type: String,
			default: '',
		},
		status: {
			type: Boolean,
			default: true,
		},
		flag: {
			type: Number,
			default: 1,
		},
		results_attribution: {
			type: Number,
			default: 1,
		},
		isKsPlatform: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		text() {
			return this.results_attribution == 0
				? '按参数链接判断归属'
				: this.results_attribution == 2
				? '按合作进度判断业绩归属'
				: this.isKsPlatform
				? '按达人跟进关系判断归属'
				: '优先按商务唯一认领关系判断归属';
		},
	},
};
</script>

<style lang="less" scoped>
.rule-card {
	padding: 20px;
	border-radius: 4px;
	background-color: #f9f9fa;
	position: relative;
	&::before {
		content: '';
		position: absolute;
		width: 4px;
		height: 16px;
		border-radius: 2px;
		background-color: @color-primary;
		left: 0;
		top: 23px;
	}
	.title {
		color: #333;
		font-weight: bold;
		.rule-explain {
			font-size: 14px;
			font-weight: 400;
			color: @color-primary;
			cursor: pointer;
		}
	}
}
</style>
